// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationPridePath = 'M13 10c0 .472-.055.931-.158 1.372C28.387 5.212 48.114 9.324 49 9.59l2.2.5 1.5 7c8.1 1.1 20.3 2.1 32.1-4.2l4.1-2.2 11 49.7-1.9 1.4c-7.2 5.2-16.2 6.6-23.8 6.6a62.602 62.602 0 01-16.1-2l-2.1-.5-1.02-4.758c-10.387-3.378-24.34-2.727-33.356 1.541l6.818 32.634-6.853 1.431L4.62 15.51A6.001 6.001 0 017 4a6 6 0 016 6zm7.166 45.694c9.494-3.943 22.34-4.771 33.158-2.283L51.7 45.833c-8.708-2.763-22.326-2.861-33.116 2.286l1.583 7.575zM48.608 31.42l1.454 6.777c-9.492-2.063-22.213-1.683-32.94 2.927l-1.52-7.276c9.392-5.52 25.119-5.116 33.006-2.428zm-34.505-4.745c9.865-4.75 23.477-4.986 32.847-2.99L45.3 15.99c-5.709-.952-21.737-2.718-32.754 3.228l1.557 7.456zM92.1 57.29c-10.4 6-24.9 3.9-30.1 2.8l-1.468-6.825c3.304.422 6.634.634 9.968.635 6.503 0 13.697-.88 19.987-3.838L92.1 57.29zM57.455 38.957l1.501 6.982c6.6 1.104 20.318 2.429 29.954-2.945l-1.656-7.42C81.231 38.757 74.203 39.7 67.9 39.7a87.193 87.193 0 01-10.445-.743zm-1.577-7.332L54.3 24.29c7.7.9 18.6 1.3 29.7-3.3l1.65 7.392c-8.892 5.94-22.531 4.42-29.772 3.243z';
var IllustrationPride = baseIllustration('IllustrationPride', {
  getPath: () => IllustrationPridePath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationPride;
//# sourceMappingURL=index.js.map